import React, { useState, useEffect } from "react";
import Section from "../Section";
import cityView from "../../assest/GreenHome/images/CityView.png";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { innerRenderPaths } from "../../assest/imgPaths";

const AboutSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);

  // Handle scroll event for image movement
  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Section bg={"bg-inherit"}>
      {/* mobile version */}
      <div className="text-primary-bg-blue col-span-full flex flex-col items-start justify-start gap-2 lg:hidden px-4 pt-12 pb-24 bg-inherit border-2">
        <div className="w-4/5 flex flex-col justify-between items-start gap-10 mb-4">
          <h2 className="text-[34px] font-extrabold tracking-[7.14px] leading-none uppercase font-gilroy">
            K2 Invest Group
          </h2>
          <div>
            კომპანია K2 INVEST- ს გააჩნია ზუსტი და თანმიმდევრულად გაწერილი
            განვითარების გეგმა, რომელიც დაფუძნებულია პროფესიონალიზმზე, მაღალ
            ხარისხზე და მაღალ სოციალურ პასუხისმგებლობაზე ...
          </div>
          <a
            href="/about"
            onClick={(event) => {
              delayNavigation(dispatch, navigate, "/about", event);
            }}
            className="flex items-center justify-center relative whitespace-nowrap w-fit cursor-pointer flex-col text-sm font-gilroy tracking-[3.36px] leading-[1.2] uppercase font-case group"
          >
            გაიგე მეტი
            <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
          </a>
        </div>

        <div
          data-v-c83bd4c6=""
          id="w-node-_888c4327-4200-3a3b-ab9a-34b87963f293-0a6b3cff"
          data-scroll=""
          className="col-span-full overflow-hidden w-fit rounded-xl"
        >
          <img
            src={innerRenderPaths[10]}
            loading="lazy"
            alt="About K2 Invest group company"
            className="rounded-xl"
            style={{
              transform: `translateY(${scrollY * 0.02}px)`, // Adjust the effect as needed
              transition: "transform 1s",
            }}
          />
        </div>
        {/* Moving Image */}
        <div
          className="col-span-9 col-start-3 row-span-1 self-center relative transform rounded-xl"
          style={{
            transform: `translateY(${scrollY * 0.03}px)`, // Adjust the effect as needed
            transition: "transform 1s",
          }}
        >
          <img
            className="rounded-xl xl:w-4/5"
            src={cityView}
            alt="kutisi city sky view"
          />
        </div>
      </div>
      {/* Desktop Version */}
      <div className="hidden text-primary-bg-blue lg:grid grid-cols-12 gap-x-[21px] col-span-full pt-12 pb-24 items-start flex-wrap auto-cols-fr grid-rows-auto justify-between relative">
        <div className="col-start-2 col-end-7 flex flex-col items-start gap-y-[21px] relative z-2">
          <h2 className="text-[34px] font-extrabold tracking-[7.14px] leading-none uppercase font-gilroy">
            K2 Invest Group
          </h2>
          <div className="text-xl tracking-wider">
            კომპანია K2 invest- ს გააჩნია ზუსტი და თანმიმდევრულად გაწერილი
            განვითარების გეგმა, რომელიც დაფუძნებულია პროფესიონალიზმზე, მაღალ
            ხარისხზე და მაღალ სოციალურ პასუხისმგებლობაზე ...
          </div>
          <a
            href="/about"
            onClick={(event) => {
              delayNavigation(dispatch, navigate, "/about", event);
            }}
            className="flex items-center justify-center relative whitespace-nowrap w-fit cursor-pointer flex-col text-sm font-gilroy tracking-[3.36px] leading-[1.2] uppercase group"
          >
            გაიგე მეტი
            <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
          </a>
          <div
            data-v-c83bd4c6=""
            id="w-node-_888c4327-4200-3a3b-ab9a-34b87963f293-0a6b3cff"
            data-scroll=""
            className="w-4/5 ml-8 rounded-lg"
            style={{
              transform: `translateY(${scrollY * 0.01}px)`, // Adjust the effect as needed
              transition: "transform 1s",
            }}
          >
            <img
              src={innerRenderPaths[10]}
              loading="lazy"
              alt="About K2 Invest group company"
              className="rounded-lg"
            />
          </div>

          <div className="m-5"></div>
        </div>
        {/* Moving Image */}
        <div
          className="col-span-4 row-span-1 self-center col-start-8 col-end-12 row-start-1 row-end-2 relative transform rounded-2xl"
          style={{
            transform: `translateY(${scrollY * 0.1}px)`, // Adjust the effect as needed
            transition: "transform 1s",
          }}
        >
          <img
            className="rounded-2xl"
            src={cityView}
            alt="kutisi city sky view"
          />
        </div>
      </div>
    </Section>
  );
};

export default AboutSection;
